// react
import { useEffect, useState } from "react";

// next
import { useRouter } from "next/router";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  getSearchPostList,
  getSearchKeywordsList,
} from "~/redux/actions/search";

import { checkPostFlags } from "~/redux/actions/post";
import { getUserInfo } from "~/redux/actions/user";

// views
import SiteLayout from "~/components/layout/SiteLayout";
import Pager from "~/components/site/Pager";
import NewPostCard from "~/components/sider/NewPostCard";
import UserSuggestCard from "~/components/sider/UserSuggestCard";
import UserRanksCard from "~/components/sider/UserRanksCard";
import SiderPromoList from "~/components/sider/SiderPromoList";
import WechatGroupCard from "~/components/site/WechatGroupCard";
import SiteRulesCard from "~/components/site/SiteRulesCard";
import PostListItem from "~/components/post/PostListItem";
import EmptyList from "~/components/app/EmptyList";
import Loading from "~/components/app/Loading";
import PostSortDropdown from "~/components/post/PostSortDropdown";
import { Card, Checkbox } from "antd";
import AppSearch from "~/components/app/AppSearch";

import lscache from "lscache";
import { pushUnique } from "~/utils/app";
import _ from "lodash";
import { isMobile } from "react-device-detect";

const Page = (props) => {
  const router = useRouter();
  const query = router.query;
  const { keyword } = query;
  const sort = query.sort;
  const [job, setJob] = useState(false);

  let keywords = lscache.get("keywords");
  if (_.trim(keyword)) {
    if (!keywords) {
      lscache.set("keywords", [keyword]);
    } else {
      if (keywords.indexOf(keyword) === -1) {
        keywords.push(keyword);
        if (keywords.length > 4) {
          keywords.shift();
        }
      } else {
        pushUnique(keywords, keyword);
      }
      lscache.set("keywords", keywords);
    }
  }

  const { searchPostList } = props;

  // 获取搜索帖子列表
  const handleFetchSearch = () => {
    props.getSearchPostList({
      q: keyword,
      page: parseInt(query.page) || 1,
      sort: sort,
      job,
    });
  };

  // 搜索贴子分页操作
  const handlePageChange = (page) => {
    router.push({
      pathname: "/search",
      query: {
        ...query,
        page: page,
      },
    });
  };

  // get keywords hot
  // const handleFetchKeywords = () => {
  //     props.getSearchKeywordsList()
  // }

  // events
  useEffect(() => handleFetchSearch(), [query, job]);
  // useEffect(() => handleFetchKeywords())

  // useEffect(() => {
  //   if (props.token && props.searchPostList && props.searchPostList.posts) {
  //     props.getUserInfo(props.token);
  //     const postIds = props.searchPostList.posts.map((post) => post.id);
  //     props.checkPostFlags(props.token, ["upvoted", "downvoted"], postIds);
  //   }
  // }, [props.searchPostList]);

  // views

  const pageSider = (
    <div>
      <NewPostCard />
      <UserSuggestCard />
      <UserRanksCard />
      <SiteRulesCard />
      <WechatGroupCard />
      <SiderPromoList />
    </div>
  );

  return (
    <SiteLayout pageSider={pageSider}>
      <Card>
        {isMobile && <AppSearch />}
        <div className="search-title flex justify-content-space-between align-items-center">
          <div>
            您搜索的关键字<span>{keyword}</span>为您找到以下内容
          </div>
          <div>
            <Checkbox className="mx-10" onChange={() => setJob(!job)}>
              只看招聘
            </Checkbox>
            <PostSortDropdown sort={sort} />
          </div>
        </div>

        <div className="post-list">
          {searchPostList ? (
            searchPostList.posts.length ? (
              searchPostList.posts.map((post) => (
                <PostListItem
                  keyword={keyword}
                  // withVote={true}
                  post={post}
                  key={post.id}
                  // upvoted={
                  //   props.flags.upvoted && props.flags.upvoted.includes(post.id)
                  // }
                  // downvoted={
                  //   props.flags.downvoted &&
                  //   props.flags.downvoted.includes(post.id)
                  // }
                />
              ))
            ) : (
              <EmptyList />
            )
          ) : (
            <Loading />
          )}
        </div>

        <Pager
          pager={searchPostList && searchPostList.pager}
          onPageChange={handlePageChange}
        />
      </Card>
      <style jsx>
        {`
          .search-title {
            font-size: 16px;
            font-weight: bold;
            border-bottom: 1px solid #f7f7f7;
            padding-bottom: 18px;
          }
          .search-title span {
            color: #f9ba48;
            padding: 0px 10px;
          }
        `}
      </style>
    </SiteLayout>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  searchPostList: state.search.searchPostList,
  keywordsList: state.search.keywordsList,
  flags: state.post.flags,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSearchPostList,
      getSearchKeywordsList,
      checkPostFlags,
      getUserInfo,
    },
    dispatch
  );

Page.requireUser = () => false;

export default connect(mapStateToProps, mapDispatchToProps)(Page);
